import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { of } from 'rxjs';

// Counter to track active requests
let activeRequests = 0;

export const UploadInterceptorFn: HttpInterceptorFn = (req, next) => {
  if (req.url === 'https://www.primefaces.org/cdn/api/upload.php') {
    const fakeResponse = new HttpResponse({
      status: 200,
      body: { success: true },
    });
    return of(fakeResponse);
  }
  return next(req);
};
